import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoDataService {

  private link!: HTMLLinkElement;
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private dom:any,
    @Inject(PLATFORM_ID) private platformId: Object,
    rendererFactory: RendererFactory2,
    private title: Title,
    private meta: Meta
  ) { 
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  createCanonicalURL(url?:string) {
    let canURL = url == undefined ? this.dom.URL.split('?')[0] : url;
    if (this.link === undefined) {
      this.link = this.dom.createElement('link');
      this.link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(this.link);
    }
    this.link.setAttribute('href', canURL);
  }

  updateTitle(title: string) {
    this.title.setTitle(title);
  }

  setMetaTags(name: any, content:any){
    this.meta.updateTag({ name: name, content: content });
  }
  removeMetaTag(name:string){
    this.meta.removeTag(name);
  };
  removeTag(){
    this.meta.removeTag('og:url');
  };

  updateOgUrl(url: string) {
    this.meta.updateTag({ name: 'og:url', content: url })
  }

  updateogProperties(property: string,desc: string){
    this.meta.updateTag({ property: property, content: desc });
  }

  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc })
  }

  appendScript(src: string, async = false) {
    const script = this.dom.createElement('script');
    script.src = src;
    script.async = async;
    this.dom.head.appendChild(script);
  }

  appendInlineScript(code: string) {
    const script = this.dom.createElement('script');
    script.type = 'text/javascript';
    script.text = code;
    this.dom.head.appendChild(script);
  }

  addNoScript(innerHtml: string) {
    const noscript = this.renderer.createElement('noscript');
    noscript.innerHTML = innerHtml;
    this.renderer.appendChild(this.dom.body, noscript);
  }
}
